const defaultState = {
  isFetching: true,
  assessmentsCount: 0,
  patientsCount: 0,
  highRiskCount: 0,
  records: [],
  weeklyData: {},
  patientsAssessedCount: 0,
};

export default (state = defaultState, action) => {

  try {
    switch (action.type) {
      case "IS_FETCHING_ANALYTICS":
        return {
          ...state,
          isFetching: false,
        };

      case "ANALYTICS":
        const assessmentsCount = action.payload.total_assessment;
        const patientsCount = action.payload.total_patients;
        const records = [
          ...action.payload.low_risk_records,
          ...action.payload.high_risk_records,
          ...action.payload.medium_risk_records,
          // ...action.payload.no_risk_records,
        ];
        const highRiskCount = action.payload.high_risk_records.length;
        const weeklyData = action.payload.weeknumber;

        const uniquePatientIds = new Set();
        records.forEach((record) => {
          uniquePatientIds.add(record.patientId);
        });
        const patientsAssessedCount = uniquePatientIds.size;

        return {
          ...state,
          assessmentsCount,
          patientsCount,
          highRiskCount,
          records,
          weeklyData,
          patientsAssessedCount,
        };

      default:
        return defaultState;
    }
  } catch (e) {
    console.log(e);
  }
};
